<script>
    import BlockBrick from "../BlockBrick.svelte";
    import BetonBrick from "../BetonBrick.svelte";

    export let x;
    export let y;
    export let width;
    export let height;
    export let els;
    export let sub;

    export let tx;
    export let ty;
    export let scale;
    export let stepScale;
    export let cw;
    export let ch;

    export let l1x;
    export let l1y;
    export let vl;

    let lWidth;
    let lHeight;
    let lScale;
    let left;
    let right;
    let top;
    let bottom;
    let hVisible;
    let vVisible;
    let visible;

    $: lWidth = width * stepScale;
    $: lHeight = height * stepScale;
    $: lScale = scale / stepScale;
    $: left = x * scale + tx;
    $: right = left + lWidth * scale;
    $: top = y * scale + ty;
    $: bottom = top + lHeight * scale;
    $: hVisible = left < cw && right > 0;
    $: vVisible = top < ch && bottom > 0;
    $: visible = hVisible && vVisible;
</script>

<div
        class="map l2"
        style="
            width: {stepScale === 4 ? lWidth : 0}px;
            height: {stepScale === 4 ? lHeight : 0}px;
            transform: {stepScale === 4 && visible ? 'translate(' + left + 'px, ' + top + 'px) scale(' + lScale + ')' : ''};
            position: {stepScale === 4 ? 'absolute' : 'static'};
            will-change: {stepScale === 4 && visible ? 'transform' : ''};
            display: {visible ? '' : 'none'};
        "
>
    {#each els as item}
        {#if (item.type === 1)}
            <BlockBrick
                    bind:x={item.x}
                    bind:y={item.y}
                    bind:tx={tx}
                    bind:ty={ty}
                    bind:l1x={l1x}
                    bind:l1y={l1y}
                    bind:l2x={x}
                    bind:l2y={y}
                    bind:step={stepScale}
                    bind:scale={scale}
                    bind:cw={cw}
                    bind:ch={ch}
                    bind:vl={vl}
            />
        {:else if (item.type === 2)}
            <BetonBrick
                    bind:x={item.x}
                    bind:y={item.y}
                    bind:tx={tx}
                    bind:ty={ty}
                    bind:l1x={l1x}
                    bind:l1y={l1y}
                    bind:l2x={x}
                    bind:l2y={y}
                    bind:step={stepScale}
                    bind:scale={scale}
                    bind:cw={cw}
                    bind:ch={ch}
                    bind:vl={vl}
            />
        {/if}
    {/each}
</div>
